// extracted by mini-css-extract-plugin
export var link = "_sz-0";